import React, { useEffect, useState } from "react";
import { Star, Quote, BadgeCheck, ChevronLeft, ChevronRight } from "lucide-react";
import { fetchReviews } from "../lib/api";

const ReviewHighlights = () => {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    fetchReviews()
      .then((data) => setItems(data.filter((r) => r.rating === 5).slice(0, 8)))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (items.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 4500);
    return () => clearInterval(t);
  }, [items.length]);

  if (items.length === 0) return null;
  const r = items[idx];
  const go = (d) => setIdx((i) => (i + d + items.length) % items.length);

  return (
    <section className="bg-gradient-to-b from-[#FFF8F0] to-[#FBF3EA] py-10" data-testid="review-highlights">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <div className="flex items-center justify-center gap-1.5 mb-3">
          <span className="text-xs font-semibold tracking-[0.2em] text-[#D46A8A] uppercase">What customers love</span>
        </div>
        <div className="relative bg-white rounded-3xl bakery-shadow px-6 md:px-14 py-8 min-h-[190px] flex flex-col items-center justify-center">
          <Quote size={40} className="text-[#F1DFC7] absolute top-5 left-6" />
          <div className="flex gap-1 mb-3">
            {[1, 2, 3, 4, 5].map((i) => <Star key={i} size={18} className="fill-[#F5A623] text-[#F5A623]" />)}
          </div>
          <p key={r.id} className="text-base md:text-lg text-[#3A2417] leading-relaxed max-w-2xl fade-up" data-testid="highlight-text">
            &ldquo;{r.message}&rdquo;
          </p>
          <div className="mt-4 flex items-center justify-center gap-2">
            <span className="font-display font-semibold text-[#6B4226]">{r.name}</span>
            {r.verified && (
              <span className="inline-flex items-center gap-1 text-[10px] font-medium text-[#2A8C4A] bg-[#E7F3E0] rounded-full px-2 py-0.5">
                <BadgeCheck size={12} /> Verified
              </span>
            )}
          </div>

          {items.length > 1 && (
            <>
              <button onClick={() => go(-1)} aria-label="Previous" className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 grid place-items-center rounded-full bg-[#FCEFE3] hover:bg-[#f6e0cf] text-[#6B4226]" data-testid="highlight-prev">
                <ChevronLeft size={18} />
              </button>
              <button onClick={() => go(1)} aria-label="Next" className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 grid place-items-center rounded-full bg-[#FCEFE3] hover:bg-[#f6e0cf] text-[#6B4226]" data-testid="highlight-next">
                <ChevronRight size={18} />
              </button>
            </>
          )}
        </div>
        {items.length > 1 && (
          <div className="flex items-center justify-center gap-2 mt-4">
            {items.map((_, i) => (
              <button key={i} onClick={() => setIdx(i)} aria-label={`Go to review ${i + 1}`} className={`h-2 rounded-full transition-all ${i === idx ? "w-6 bg-[#D46A8A]" : "w-2 bg-[#EADBCB]"}`} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ReviewHighlights;
